import { render, staticRenderFns } from "./CoinCardScanner.vue?vue&type=template&id=6c8fa5de&"
import script from "./CoinCardScanner.vue?vue&type=script&lang=js&"
export * from "./CoinCardScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports